export const BACKEND_URL = 'https://afternoon-falls-25894.herokuapp.com';
export const WORD_REQUEST_URL = `${BACKEND_URL}/words?`;
export const WORD_INFO_REQUEST_URL = `https://afternoon-falls-25894.herokuapp.com/words/`;
export const DATA_LINK = 'https://raw.githubusercontent.com/alexeikravchuk/rslang-data/master/';
